import React, { useCallback, useEffect, useState } from "react";
import styles from "../auth/AuthLayout.module.css";
import { login } from "../../api/api";
import AuthTokenService from "./AuthTokenService";
import { useSearchParams } from "react-router-dom";

const REDIRECT_URI = `${import.meta.env.VITE_IMC_LOGIN_URI}?responseCallback=${encodeURIComponent(document.location.origin)}&requestOrigin=IDM`;

interface AuthLayoutProps {
    onAuthChange?: (isLoggedIn: boolean) => void;
}
enum LayoutView {
    Login,
    Redirect,
    Error,
    Success
}
const AuthLayout: React.FC<AuthLayoutProps> = ({ onAuthChange }) => {
    const [currentQueryParameters, setSearchParams] = useSearchParams();
    const idmResponse = currentQueryParameters.get("idmresponse");

    const [inProgress, setInProgress] = useState(LayoutView.Redirect);
    const [message, setMessage] = useState({ message: "", isSuccess: false });
    const hideMessage = () => setMessage({ message: "", isSuccess: false });
    const showMessage = useCallback((text: string, isSuccess: boolean) => {
        setMessage({ message: text, isSuccess: isSuccess });
        setTimeout(() => {
            hideMessage();
        }, 10000);
    }, []);

    const { setToken } = AuthTokenService(onAuthChange);

    useEffect(() => {
        if (!idmResponse && inProgress == LayoutView.Redirect) {
            document.location.href = REDIRECT_URI;
            return;
        }

        if (idmResponse && inProgress == LayoutView.Redirect) {
            setInProgress(LayoutView.Login);
            login(idmResponse)
                .then(r => {
                    if (r.error) {
                        showMessage(r.error.title ?? "Login failed", false);
                        setInProgress(LayoutView.Error);
                    } else {
                        showMessage(r.data.message, !r.data.isFailed);
                        r.data.token && setToken(r.data);
                        const newQueryParameters: URLSearchParams = new URLSearchParams();
                        setSearchParams(newQueryParameters);

                        setInProgress(LayoutView.Success);
                    }
                })
                .catch(e => {
                    showMessage(e ?? "Login failed", false);
                    setInProgress(LayoutView.Error);
                });
        }
    }, [inProgress, idmResponse, setToken, showMessage, setSearchParams]);

    return (
        <div className={styles.authContainer}>
            <div>
                {message.message && (
                    <div className={`alert alert-warning ${message.isSuccess ? styles.successMessage : styles.alertMessage}`}>
                        <span>{message.message}</span>
                        {/* <button onClick={() => hideMessage()} className={styles.closeButton}>
                            &times;
                        </button> */}
                    </div>
                )}
            </div>
            <h2 className={styles.header}>{inProgress == LayoutView.Redirect ? "Redirecting..." : "Login"}</h2>
            {inProgress == LayoutView.Error && (
                <div className={styles.buttonGroup}>
                    <button
                        onClick={() => {
                            document.location.href = REDIRECT_URI;
                        }}
                        className={styles.button}
                    >
                        Try again
                    </button>
                </div>
            )}
        </div>
    );
};

export default AuthLayout;
